var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFocus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path\n            {\n                fill: #263c53;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.34,134.35H29v67.87H79.34Zm-15,52.87H44V149.35H64.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151,92.91H100.6V202.22H151Zm-15,94.31H115.6V107.91H136Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.62,36.45H172.24V202.22h50.38Zm-15,150.77H187.24V51.45h20.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.13bead1a7654c1086a071a7000c41abe.svg";
export { ForwardRef as ReactComponent };